import Vue from "vue";
import Router from "vue-router";
import MercureRatesHorizontalV1 from "@/components/mercure/rates/horizontal/v1/mercureRatesHorizontalV1.vue";
import BarriereChangeHorizontalV1 from "@/components/barriere/change/horizontal/v1/barriereChangeHorizontalV1.vue";
import IbisRatesHorizontalV1 from "@/components/ibis/rates/horizontal/v1/ibisRatesHorizontalV1.vue";
import IbisRatesHorizontalV2 from "@/components/ibis/rates/horizontal/v2/ibisRatesHorizontalV2.vue";
import NovotelRatesHorizontalV1 from "@/components/novotel/rates/horizontal/v1/novotelRatesHorizontalV1.vue";
import IbisStylesRatesHorizontalV1 from "@/components/ibisstyles/rates/horizontal/v1/ibisstylesRatesHorizontalV1.vue";
import TribeRatesHorizontalV1 from "@/components/tribe/rates/horizontal/v1/tribeRatesHorizontalV1";
import NovotelRatesHorizontalV2 from "@/components/novotel/rates/horizontal/v2/novotelRatesHorizontalV2.vue";
import MercureRatesHorizontalV2 from "@/components/mercure/rates/horizontal/v2/mercureRatesHorizontalV2.vue";
import Redirect from "@/components/routing/Redirect";
import Params from "@/components/params/params";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/mercure/rates/v1/:hotel",
      name: "MercureRates",
      component: MercureRatesHorizontalV1
    },
    {
      path: "/mercure/rates/v2/:hotel",
      name: "MercureRates",
      component: MercureRatesHorizontalV2
    },
    {
      path: "/barriere/change/v1/:hotel",
      name: "BarriereChange",
      component: BarriereChangeHorizontalV1
    },
    {
      path: "/ibis/rates/v1/:hotel",
      name: "IbisRates",
      component: IbisRatesHorizontalV1
    },
    {
      path: "/ibis/rates/v2/:hotel",
      name: "IbisRates",
      component: IbisRatesHorizontalV2
    },
    {
      path: "/novotel/rates/v1/:hotel",
      name: "NovotelRates",
      component: NovotelRatesHorizontalV1
    },
    {
      path: "/novotel/rates/v2/:hotel",
      name: "NovotelRates",
      component: NovotelRatesHorizontalV2
    },
    {
      path: "/ibisstyles/rates/v1/:hotel",
      name: "IbisStylesRates",
      component: IbisStylesRatesHorizontalV1
    },
    {
      path: "/tribe/rates/v1/:hotel",
      name: "TribeRates",
      component: TribeRatesHorizontalV1
    },
    {
      path: "/params",
      name: "Params",
      component: Params
    },
    {
      path: "/",
      name: "Redirect",
      component: Redirect
    }
  ]
});



// WEBPACK FOOTER //
// ./src/tools/router/index.js